import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1d": "#E0E0E0",
    "col1n": "#FFFFFF",
    "col1s": "#C2C2C2"
}
function AccHat170({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M174.1 90.7l9-29.5-23.75 1.15-1.65-1.5-.2-.2-.2-.2L91.55 0 25 61.2h-.15l-1.3 1.1L0 61.2l9 29.5 82.55 4.2 82.55-4.2z"
                    id="AccHat170__Symbol_564_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1d}
                    d="M82.55 90.7l9-29.5-23.75 1.15-1.65-1.5-.2-.2-.2-.2L0 0v94.9l82.55-4.2z"
                    id="AccHat170__Symbol_565_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1s}
                    d="M135.8 1.35L134.35 0 68.3 3.3l-.3-.05L1.7 0l-.25.2H1.3L0 1.3l68 3.45 67.8-3.4z"
                    id="AccHat170__Symbol_566_0_Layer0_0_FILL"
                />
            </defs>
            <use
                xlinkHref="#AccHat170__Symbol_564_0_Layer0_0_FILL"
                transform="translate(101.05 13.95)"
                id="AccHat170__col1n"
            />
            <use
                xlinkHref="#AccHat170__Symbol_565_0_Layer0_0_FILL"
                transform="translate(192.6 13.95)"
                id="AccHat170__col1d"
            />
            <use
                xlinkHref="#AccHat170__Symbol_566_0_Layer0_0_FILL"
                transform="translate(124.6 74.95)"
                id="AccHat170__col1s"
            />
        </g></g>
    )
}
export default AccHat170
